<template lang="pug">
  div(v-app-scroll="handleScroll")
    v-app-bar.app-bar-bg(:style="onTop" id="home-app-bar" app color="#0E9DBC" elevation="0" height="112")
      v-layout.goscontainer
        router-link( to="/") 
            img.home__logo-icon(src="/logo-main.svg" width="239")
        
        v-spacer
        
        v-flex.text-right(class="hidden-sm-and-down" optional align-self-center)
          div.home__page-link
            v-btn.mb-1.mx-2.py-3.px-3(
              v-for="(item, i) in items"
              :key="item.title"
              text 
              @click="handleSelect(item)"
              :color="item.color" ) 
                  v-icon.mr-2(v-if="item.icon && item.icon!=''" color="red" size="24") {{ item.icon }}
                  |{{ item.title }}
        
        
        v-app-bar-nav-icon(class="hidden-md-and-up" @click="drawer = !drawer")
    home-drawer( v-model="drawer" :items="items" @clicked="handleSelect")
</template>

<script>
import Meeting from '@/common/Meeting'

  export default {
    name: 'HomeAppBar',
    mixins: [Meeting],

    props: {
      cmsOn: {
          default:false,
          type:Boolean
      }
    },

    components: {
      HomeDrawer: () => import('./Drawer'),
    },

    methods: {
      handleSelect (item) {
        if (item.action) 
          item.action()
      }, 
      handleScroll () {
        this.top = window.scrollY
      }
    },

    computed: {
      items () {
        let items = []

        if (this.cmsOn) items.push({ icon:'', color:'normal', title:'ПОИСК ДЕЛ', action: () => location.href = `/searchcase` })
        if (this.$_meeting_eisa_isAvailable) items.push({ icon:'', color:'normal', title:'ВОЙТИ ЧЕРЕЗ ГОСУСЛУГИ (ЕСИА)', action: () => this.$emit('clicked', 'esia') })
        if (this.$_meeting_isAvailable) items.push({ icon:'', color:'normal', title:'ВОЙТИ ПО ПИН-КОДУ', action: () => this.$emit('clicked', 'pin') })
        if (this.cmsOn) items.push({ icon:'', color:'normal', title:'ПОМОЩЬ', action: () => this.$router.push({ path: `/page/sp_help` }) })
        items.push({ icon:'', color:'normal', title:'ЛИЧНЫЙ КАБИНЕТ', action: () => this.$emit('clicked', 'cab') })
        
        return items
      },
      onTop() {
        return this.top==0 ? "background-image: url(/bg.png)" : "background-image: none"
      }
    },

    data: () => ({
      top: 0,
      drawer: null,
    }),
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
  .app-bar-bg
    background-color: #0E9DBC url(/bg.png) top right no-repeat
    background-position: top right
    background-repeat: no-repeat

</style>
